import { ElegantShape } from "../ui/ElegantShape";

export function GeometricBackground({ variant = "default", className = "absolute inset-0" }) {
    return (
        <div className={`${className} overflow-hidden pointer-events-none`}>
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/[0.05] via-transparent to-rose-500/[0.05] blur-3xl" />

            {/* DESKTOP VIEW (Completely Unchanged Original) */}
            <div className="hidden md:block absolute inset-0">
                {variant === "default" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={600}
                            height={140}
                            rotate={12}
                            gradient="from-indigo-500/[0.15]"
                            className="left-[-10%] md:left-[-5%] top-[15%] md:top-[20%]"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={500}
                            height={120}
                            rotate={-15}
                            gradient="from-rose-500/[0.15]"
                            className="right-[-5%] md:right-[0%] top-[70%] md:top-[75%]"
                        />
                        <ElegantShape
                            delay={0.4}
                            width={300}
                            height={80}
                            rotate={-8}
                            gradient="from-violet-500/[0.15]"
                            className="left-[5%] md:left-[10%] bottom-[5%] md:bottom-[10%]"
                        />
                        <ElegantShape
                            delay={0.6}
                            width={200}
                            height={60}
                            rotate={20}
                            gradient="from-amber-500/[0.15]"
                            className="right-[15%] md:right-[20%] top-[10%] md:top-[15%]"
                        />
                        <ElegantShape
                            delay={0.7}
                            width={150}
                            height={40}
                            rotate={-25}
                            gradient="from-cyan-500/[0.15]"
                            className="left-[20%] md:left-[25%] top-[5%] md:top-[10%]"
                        />
                    </>
                )}

                {variant === "login" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={700}
                            height={160}
                            rotate={-10}
                            gradient="from-cyan-500/[0.15]"
                            className="left-[-5%] top-[10%]"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={400}
                            height={100}
                            rotate={15}
                            gradient="from-emerald-500/[0.15]"
                            className="right-[5%] bottom-[20%]"
                        />
                        <ElegantShape
                            delay={0.4}
                            width={300}
                            height={80}
                            rotate={-5}
                            gradient="from-blue-500/[0.15]"
                            className="left-[25%] bottom-[5%]"
                        />
                    </>
                )}

                {variant === "register" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={600}
                            height={140}
                            rotate={20}
                            gradient="from-pink-500/[0.15]"
                            className="right-[-10%] top-[15%]"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={500}
                            height={120}
                            rotate={-15}
                            gradient="from-purple-500/[0.15]"
                            className="left-[-5%] bottom-[15%]"
                        />
                        <ElegantShape
                            delay={0.4}
                            width={300}
                            height={80}
                            rotate={10}
                            gradient="from-orange-500/[0.15]"
                            className="right-[20%] bottom-[5%]"
                        />
                    </>
                )}

                {variant === "forgot-password" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={600}
                            height={140}
                            rotate={-20}
                            gradient="from-yellow-500/[0.15]"
                            className="left-[-10%] top-[20%]"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={500}
                            height={120}
                            rotate={15}
                            gradient="from-red-500/[0.15]"
                            className="right-[-5%] bottom-[20%]"
                        />
                        <ElegantShape
                            delay={0.4}
                            width={300}
                            height={80}
                            rotate={-10}
                            gradient="from-orange-500/[0.15]"
                            className="left-[20%] bottom-[10%]"
                        />
                    </>
                )}

                {variant === "home" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={900}
                            height={300}
                            rotate={-15}
                            gradient="from-indigo-900/[0.10]"
                            className="left-[-20%] top-[-10%] opacity-50"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={800}
                            height={300}
                            rotate={15}
                            gradient="from-purple-900/[0.10]"
                            className="right-[-10%] top-[40%] opacity-50"
                        />
                        <ElegantShape
                            delay={0.4}
                            width={600}
                            height={200}
                            rotate={-5}
                            gradient="from-blue-900/[0.10]"
                            className="left-[10%] bottom-[-10%] opacity-50"
                        />
                    </>
                )}
            </div>

            {/* MOBILE VIEW (Modified to be Smaller and Opaque) */}
            <div className="block md:hidden absolute inset-0">
                {variant === "default" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={300}
                            height={70}
                            rotate={12}
                            gradient="from-indigo-500/[0.15]"
                            className="left-[-15%] top-[10%] opacity-40"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={250}
                            height={60}
                            rotate={-15}
                            gradient="from-rose-500/[0.15]"
                            className="right-[-10%] top-[80%] opacity-40"
                        />
                        <ElegantShape
                            delay={0.4}
                            width={150}
                            height={40}
                            rotate={-8}
                            gradient="from-violet-500/[0.15]"
                            className="left-[10%] bottom-[5%] opacity-50"
                        />
                    </>
                )}

                {variant === "login" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={350}
                            height={80}
                            rotate={-10}
                            gradient="from-cyan-500/[0.15]"
                            className="left-[-15%] top-[5%] opacity-40"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={200}
                            height={50}
                            rotate={15}
                            gradient="from-emerald-500/[0.15]"
                            className="right-[0%] bottom-[15%] opacity-40"
                        />
                    </>
                )}

                {variant === "register" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={300}
                            height={70}
                            rotate={20}
                            gradient="from-pink-500/[0.15]"
                            className="right-[-15%] top-[10%] opacity-40"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={250}
                            height={60}
                            rotate={-15}
                            gradient="from-purple-500/[0.15]"
                            className="left-[-15%] bottom-[10%] opacity-40"
                        />
                    </>
                )}

                {variant === "forgot-password" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={300}
                            height={70}
                            rotate={-20}
                            gradient="from-yellow-500/[0.15]"
                            className="left-[-15%] top-[15%] opacity-40"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={250}
                            height={60}
                            rotate={15}
                            gradient="from-red-500/[0.15]"
                            className="right-[-10%] bottom-[15%] opacity-40"
                        />
                    </>
                )}

                {variant === "home" && (
                    <>
                        <ElegantShape
                            delay={0.3}
                            width={450}
                            height={150}
                            rotate={-15}
                            gradient="from-indigo-900/[0.10]"
                            className="left-[-25%] top-[-5%] opacity-30"
                        />
                        <ElegantShape
                            delay={0.5}
                            width={400}
                            height={150}
                            rotate={15}
                            gradient="from-purple-900/[0.10]"
                            className="right-[-15%] top-[50%] opacity-30"
                        />
                        <ElegantShape
                            delay={0.4}
                            width={300}
                            height={100}
                            rotate={-5}
                            gradient="from-blue-900/[0.10]"
                            className="left-[5%] bottom-[-5%] opacity-30"
                        />
                    </>
                )}
            </div>
        </div>
    );
}
